/**
 * メートル単位の距離をm/kmで整形された文字列に変換する
 * L.GeometryUtil.readableDistance()もあるが、少数の表示を細かく制御するため別実装にしています
 * @param distance メートル単位の距離
 * @returns 整形後の距離文字列（例: "500 m", "1.50 km"）
 */
export const readableDistance = (distance: number): string => {
  return distance >= 1000
    ? `${(distance / 1000).toFixed(2)} km`
    : `${distance.toFixed(1)} m`;
};

/**
 * 面積の数値を整形し、人間が読みやすい形にする
 * @param value 面積
 * @return 整形後の文字列
 */
export const readableArea = (value: number): string => {
  /*
    L.GeometryUtil.readableArea()について
    L.GeometryUtil.readableArea(value)を使用すると面積の数値を四捨五入したり、単位換算をすることができる
    しかし、この関数にはバグがあり正常に動作しない
    対策はあるにはあるが今回はこの関数は使用しないことにした
    参考: https://github.com/Leaflet/Leaflet.draw/issues/1026
  */

  // 四捨五入し、カンマを挿入する
  const result = Math.round(value).toLocaleString("ja-JP");
  return `${result}m²`;
};
